<script>
import simplebar from "simplebar-vue";
import i18n from "../i18n";
import Swal from "sweetalert2";
import { layoutComputed } from "@/state/helpers";
import { http } from "@/helpers/easyindustriaapi/config";

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
    // Só notificações com professional_aware igual a false (ou sem recorrência)
    notificationsToShow() {
      return this.notifications.filter((n) => n.professional_aware !== true);
    },
    unreadNotificationsCount() {
      return this.notificationsToShow.length;
    },
  },
  components: { simplebar },
  data() {
    return {
      user: null,
      notifications: [],
      notificationChannel: null,
      notificationsPollInterval: null,
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/br.png"),
          language: "br",
          title: "Português BR",
        },
      ],
      current_language: "br",
    };
  },
  created() {
    i18n.locale = this.current_language;
    this.current_language = i18n.locale;
    try {
      this.user = JSON.parse(localStorage.getItem('user') || 'null') || {};
    } catch (_) {
      this.user = {};
    }

    // Configurar listener de notificações via Pusher
    this.setupNotifications();
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value ? this.value.title : '';
    this.flag = this.value ? this.value.flag : null;
    // Polling de notificações persistidas (fallback quando Pusher não entrega, ex.: após autorizar atendimento)
    this.fetchPendingNotifications();
    this.notificationsPollInterval = setInterval(() => {
      this.fetchPendingNotifications();
    }, 25000);
  },
  beforeDestroy() {
    if (this.notificationsPollInterval) {
      clearInterval(this.notificationsPollInterval);
    }
    if (this.notificationChannel) {
      this.notificationChannel.unbind('nova.notificacao');
    }
  },
  methods: {
    
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    openSettingsDrawer() {
      this.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    setLanguage(locale) {
      i18n.locale = locale;
      this.current_language = i18n.locale;
    },

    // Alerta sonoro (WebAudio) para novos itens no sino.
    // Evita depender de arquivo de áudio externo.
    playNotificationSound() {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext
        if (!AudioContext) return

        if (!this._notificationAudioCtx) {
          this._notificationAudioCtx = new AudioContext()
        }
        const ctx = this._notificationAudioCtx
        if (ctx.state === 'suspended') {
          // Alguns navegadores exigem gesto do usuário; tentamos reativar.
          void ctx.resume && ctx.resume()
        }

        const oscillator = ctx.createOscillator()
        const gain = ctx.createGain()

        oscillator.type = 'sine'
        oscillator.frequency.value = 880

        gain.gain.value = 0.0001
        oscillator.connect(gain)
        gain.connect(ctx.destination)

        const now = ctx.currentTime
        oscillator.start(now)
        gain.gain.exponentialRampToValueAtTime(0.06, now + 0.01)
        gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.15)
        oscillator.stop(now + 0.16)
      } catch (e) {
        // Browser pode bloquear autoplay; não quebra o fluxo do app.
        console.warn('Falha ao reproduzir som de notificação:', e)
      }
    },
    // Configurar listener de notificações via Pusher
    setupNotifications() {
      if (!this.user || !this.user.id) {
        return;
      }

      if (!window.pusher) {
        return;
      }

      // Canal privado: App.Models.User.{id}
      // No Pusher, canais privados são prefixados com 'private-'
      const channelName = `private-App.Models.User.${this.user.id}`;

      try {
        const trySubscribe = () => {
          if (window.pusher.connection.state === 'connected') {
            this.subscribeToChannel(channelName);
          } else {
            const onConnected = () => {
              window.pusher.connection.unbind('connected', onConnected);
              this.subscribeToChannel(channelName);
            };
            window.pusher.connection.bind('connected', onConnected);
          }
        };

        trySubscribe();
      } catch (error) {
        console.error('Erro ao configurar notificações:', error);
      }
    },
    subscribeToChannel(channelName) {
      try {
        this.notificationChannel = window.pusher.subscribe(channelName);

        this.notificationChannel.bind('pusher:subscription_succeeded', () => {});

        this.notificationChannel.bind('pusher:subscription_error', (status) => {
          console.error('Erro ao inscrever no canal de notificações:', status);
        });

        this.notificationChannel.bind('nova.notificacao', (data) => {
          const incomingId =
            data && data.id != null && Number.isInteger(data.id) && data.id > 0 ? data.id : null
          if (incomingId != null && this.notifications.some((n) => n.id === incomingId)) {
            return
          }

          const notifId = incomingId ?? Date.now() + Math.random()

          this.notifications.unshift({
            id: notifId,
            titulo: data.titulo || 'Nova Notificação',
            mensagem: data.mensagem || '',
            icone: data.icone || 'ri-notification-line',
            imagem: data.imagem || null,
            link: data.link || '#',
            horario: data.horario || 'agora',
            recurrence_id: data.recurrence_id || null,
            professional_aware: false,
          });

          if (this.notifications.length > 50) {
            this.notifications = this.notifications.slice(0, 50);
          }

          // Outras telas (ex.: agenda do profissional) precisam reagir à mesma notificação
          // mesmo quando o Pusher não entrega no segundo subscribe ou quando só há polling.
          this.emitUserNotificationBridge(data);

          // Somente para item realmente novo no sino.
          this.playNotificationSound();
        });
      } catch (error) {
        console.error('Erro ao configurar notificações:', error);
      }
    },
    /**
     * Repassa payload de notificação para o restante do app (ex.: modal Parecer na agenda).
     * Evento único: mesmo formato que o Pusher envia em nova.notificacao.
     */
    emitUserNotificationBridge(payload) {
      try {
        this.$root.$emit('easysaude:user-notification', payload);
      } catch (_) {
        /* noop */
      }
    },
    // Buscar notificações persistidas (fallback quando Pusher não entrega)
    async fetchPendingNotifications() {
      if (!this.user || !this.user.id) return;
      try {
        const { data } = await http.get('/notifications');
        const list = Array.isArray(data) ? data : (data && data.data) ? data.data : [];
        const existingIds = new Set(this.notifications.map((n) => n.id).filter((id) => typeof id === 'number'));
        let newlyAdded = 0;
        for (const n of list) {
          if (!n || n.id == null) continue;
          if (n.recurrence_id != null && n.professional_aware) continue;
          if (existingIds.has(n.id)) continue;
          existingIds.add(n.id);
          this.notifications.unshift({
            id: n.id,
            titulo: n.titulo || 'Notificação',
            mensagem: n.mensagem || '',
            icone: n.icone || 'ri-notification-line',
            link: n.link || '#',
            horario: n.horario || 'agora',
            recurrence_id: n.recurrence_id ?? null,
            professional_aware: n.professional_aware ?? false,
          });
          this.emitUserNotificationBridge({
            id: n.id,
            titulo: n.titulo,
            mensagem: n.mensagem,
            icone: n.icone,
            link: n.link,
            horario: n.horario,
            recurrence_id: n.recurrence_id ?? null,
            professional_aware: n.professional_aware ?? false,
          });
          newlyAdded++;
        }
        this.notifications = this.notifications.filter((n) => !(n.recurrence_id && n.professional_aware));
        if (this.notifications.length > 50) {
          this.notifications = this.notifications.slice(0, 50);
        }
        if (newlyAdded > 0) {
          this.playNotificationSound();
        }
      } catch (_) {
        // ignora erros ao buscar notificações
      }
    },
    async clearNotifications() {
      try {
        await http.post('/notifications/mark-all-read');
      } catch (_) {
        // ignora erro; limpa a lista local mesmo assim
      }
      this.notifications = [];
    },
    async sendTestNotification() {
      try {
        const { data } = await http.post('/notifications/test', {
          titulo: 'Notificação de teste',
          mensagem: 'Esta notificação foi disparada para validar o canal.',
        });
        // Exibir na hora a notificação (evita depender do Pusher no dropdown)
        if (data && (data.titulo || data.mensagem)) {
          this.notifications.unshift({
            id: Date.now() + Math.random(),
            titulo: data.titulo || 'Notificação de teste',
            mensagem: data.mensagem || '',
            icone: data.icone || 'ri-notification-3-line',
            link: data.link || '#',
            horario: data.horario || new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
          });
        }
      } catch (e) {
        console.error('Erro ao enviar notificação de teste:', e);
      }
    },
    // Método para lidar com clique na notificação: marca como lida e navega
    async handleNotificationClick(notif) {
      if (!notif.link || notif.link === '#') return;
      const id = notif.id != null && Number.isInteger(notif.id) && notif.id > 0 && notif.id < 1000000 ? notif.id : null;
      if (id) {
        try {
          await http.put(`/notifications/${id}/mark-read`);
        } catch (_) {
          void _; // ignora erro; remove da lista mesmo assim
        }
      }
      const idx = this.notifications.findIndex((n) => n === notif || (n.id != null && n.id === notif.id));
      if (idx !== -1) this.notifications.splice(idx, 1);
      if (notif.link.startsWith('/')) {
        if (this.$route.path !== notif.link) {
          this.$router.push(notif.link);
        }
      } else {
        window.location.href = notif.link;
      }
    },
    // Notificação de atendimento autorizado (exibe botão Estou ciente, ativo ou desabilitado)
    isAuthorizedAttendanceNotification(notif) {
      return notif && (notif.titulo === 'Atendimento autorizado' || (notif.recurrence_id != null));
    },
    // Marcar recorrência como ciente (profissional está ciente da evolução/autorização)
    async markProfessionalAware(notif, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!notif) return;
      if (notif.professional_aware) return;
      try {
        if (notif.recurrence_id) {
          const empresa = JSON.parse(localStorage.getItem('currentEmpresa') || 'null');
          await http.put('/atendimento/recurrence/' + notif.recurrence_id + '/professional-aware', null, {
            params: { empresa_id: empresa && empresa.id },
          });
        } else if (Number.isInteger(notif.id) && notif.id > 0 && notif.id < 1000000) {
          await http.put('/notifications/' + notif.id + '/mark-professional-aware');
        } else {
          Swal.fire({ icon: 'error', title: 'Erro', text: 'Não foi possível marcar como ciente para esta notificação.' });
          return;
        }

        // Ponte de estado (modal/listas) para refletir "ciente" sem depender de polling.
        if (notif.recurrence_id) {
          this.$root.$emit('easysaude:professional-aware-updated', {
            recurrence_id: notif.recurrence_id,
            professional_aware: true,
          });
        }

        const idx = this.notifications.findIndex((n) => n === notif || (notif.id != null && n.id === notif.id) || (n.recurrence_id != null && n.recurrence_id === notif.recurrence_id && (n.titulo === notif.titulo && n.horario === notif.horario)));
        if (idx !== -1) this.notifications.splice(idx, 1);
        Swal.fire({ icon: 'success', title: 'Sucesso', text: 'Você marcou como ciente desta notificação.' });
      } catch (e) {
        const msg = e.response && e.response.data && (e.response.data.error || e.response.data.message) ? (e.response.data.error || e.response.data.message) : (e.message || 'Erro ao marcar como ciente.');
        Swal.fire({ icon: 'error', title: 'Erro', text: msg });
      }
    },
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link :to="{name: 'professional-calendar'}" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm-dark.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="20" />
            </span>
          </router-link>

          <router-link :to="{name: 'professional-calendar'}" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm-light.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt height="20" />
            </span>
          </router-link>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-24 d-lg-none header-item"
          data-toggle="collapse"
          @click="toggleMenu"
        >
          <i class="ri-menu-2-line align-middle"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('navbar.search.text')"
            />
            <span class="ri-search-line"></span>
          </div>
        </form>
      </div>

      <div class="d-flex">
        <div class="dropdown d-inline-block d-lg-none ml-2">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            id="page-header-search-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="ri-search-line"></i>
          </button>
          <div
            class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
            aria-labelledby="page-header-search-dropdown"
          >
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search ..."
                  />
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit">
                      <i class="ri-search-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img
              class
              src="@/assets/images/flags/br.png"
              alt="Header Language"
              height="16"
            />
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language)"
            :link-class="{ active: entry.language === current_language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="mr-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            data-toggle="fullscreen"
            @click="initFullScreen"
          >
            <i class="ri-fullscreen-line"></i>
          </button>
        </div>

        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="ri-notification-3-line"></i>
            <span v-if="unreadNotificationsCount > 0" class="badge badge-pill badge-danger badge-up">
              {{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}
            </span>
          </template>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <a href="#!" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <div
              v-for="(notif, index) in notificationsToShow"
              :key="notif.id || index"
              class="notification-item d-flex align-items-start text-reset"
            >
              <a
                :href="notif.link || '#'"
                class="flex-grow-1 text-reset text-decoration-none"
                @click.prevent="handleNotificationClick(notif)"
              >
                <div class="media">
                  <div class="avatar-xs mr-3">
                    <img
                      v-if="notif.imagem"
                      :src="notif.imagem"
                      class="rounded-circle avatar-xs"
                      alt="user-pic"
                    />
                    <span v-else class="avatar-title bg-primary rounded-circle font-size-16">
                      <i :class="notif.icone ? notif.icone : 'ri-notification-line'"></i>
                    </span>
                  </div>
                  <div class="media-body">
                    <h6 class="mt-0 mb-1">{{ notif.titulo }}</h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">{{ notif.mensagem }}</p>
                      <p class="mb-0">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ notif.horario }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
              <button
                v-if="isAuthorizedAttendanceNotification(notif)"
                type="button"
                :class="['btn btn-sm ml-2 align-self-center', notif.recurrence_id && !notif.professional_aware ? 'btn-success' : 'btn-secondary']"
                title="Estou ciente"
                @mousedown.stop
                @click.stop.prevent="markProfessionalAware(notif, $event)"
              >
                <i class="ri-checkbox-circle-fill font-size-16 mr-1"></i>
                Estou ciente
              </button>
            </div>

            <div v-if="notificationsToShow.length === 0" class="text-center p-3 text-muted">
              <p class="mb-0">Nenhuma notificação nova</p>
            </div>
          </simplebar>
          <div class="p-2 border-top">
            <a v-if="this.user.roles.some(role => role.name === 'super')"
              href="javascript:void(0)"
              class="btn btn-sm btn-link font-size-14 btn-block text-center"
              @click.prevent="sendTestNotification"
            >
              <i class="ri-send-plane-line mr-1"></i>
              Enviar notificação de teste
            </a>
            <a
              v-if="notificationsToShow.length > 0"
              class="btn btn-sm btn-link font-size-14 btn-block text-center"
              href="javascript:void(0)"
              @click.prevent="clearNotifications"
            >
              <i class="mdi mdi-check-all mr-1"></i>
              Limpar Notificações
            </a>
            <a
              v-else
              class="btn btn-sm btn-link font-size-14 btn-block text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle mr-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div>
        </b-dropdown>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/no-avatar.jpg"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ml-1">{{ (user && user.username) || '' }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <a class="dropdown-item" href="#">
            <i class="ri-user-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.megamenu.profile.title') }}
          </a>
          <a class="dropdown-item d-block" href="/logout">
            <i class="ri-lock-unlock-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.megamenu.look.title') }}
          </a>
          <a class="dropdown-item" href="https://tv.easysaude.click" target="_blank">
            <i class="ri-tv-line align-middle mr-1"></i>
            TV EasySaúde
          </a>
          <router-link :to="{name: 'SelectCompany'}" tag="a" class="dropdown-item">
            <i class="ri-lock-unlock-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.megamenu.selectcompany.title') }}
          </router-link>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="/logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t('navbar.dropdown.megamenu.logout.title') }}
          </a>
        </b-dropdown>
        <div class="dropdown d-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect toggle-right"
            :title="$t('navbar.dropdown.megamenu.settings.title')"
            @click.prevent="openSettingsDrawer"
          >
            <i class="ri-settings-2-line"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>